import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useConfig, useErrorHandler } from '~hooks';
import { setConfig } from '~redux/reducers/configSlice';

type ConfiguratorProviderProps = { readonly children?: React.ReactNode };

function ConfiguratorProvider(props: ConfiguratorProviderProps) {
  const { children } = props;

  const dispatch = useDispatch();
  const throwError = useErrorHandler();

  const [config, loading, error] = useConfig();

  useEffect(() => {
    if (config) {
      dispatch(setConfig(config));
    }
  }, [dispatch, config]);

  // Propagate config error to ErrorBoundary
  useEffect(() => {
    if (error && !loading) {
      throwError(error);
    }
  }, [error, loading, throwError]);

  return <>{children}</>;
}

ConfiguratorProvider.defaultProps = {
  children: undefined,
};

export { ConfiguratorProvider };
